export const DAY_IN_MICROSECONDS = 1000 * 3600 * 24;

export const getMsDifferenceInDays = (date1, date2) => {
    const timeDiff = Math.abs(date2 - date1);

    return timeDiff / DAY_IN_MICROSECONDS;
};
